import React from 'react';
import classNames from 'classnames';

export enum BadgeColor {
  BLUE = 'blue',
  PINK = 'pink',
  GREEN = 'green',
}

const colors = {
  [BadgeColor.BLUE]: 'bg-blue-100 text-gray-800',
  [BadgeColor.PINK]: 'bg-pink-100 text-pink-800',
  [BadgeColor.GREEN]: 'bg-green-100 text-green-800',
}

interface BadgeProps {
  color: BadgeColor,
  text: string,
}

const Badge: React.FC<BadgeProps> = ({ color, text }) => (
  <span className={classNames('px-2.5 py-0.5 inline-flex text-xs leading-5 font-semibold rounded-full', colors[color])}>
    {text}
  </span>
);


export default Badge;


